/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_ProviderInputs */



/**
* | output |
* | --- |
* | "Something went wrong while generating the response. Please try again." |
*
* @param {Chat_Error_ProviderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_provider = /** @type {((inputs?: Chat_Error_ProviderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_ProviderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Generieren der Antwort ist ein Fehler aufgetreten. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Something went wrong while generating the response. Please try again.")
});